import React, { useState, useEffect } from 'react';
import styles from './UserDetails.module.css';
import SocioDemo from './components/SocioDemo/SocioDemo';
import StepsProgress from '../../../StepsProgress/StepsProgress';
import Footer from '../../../Footer/Footer';

export default props => {
  const {
    translations,
    choices,
    startWebSurvey,
    campaign,
    userId,
    error,
    isTesting,
    match,
    page,
    pages,
    onClickBack,
    userDetailsCompleted,
    setUserDetailsCompleted,
    userDetails,
    setUserDetails,
    steps,
    customThemeBaseColor,
    translationInputFieldProps,
    onUpdateLocalCustomCopy
  } = props;

  const [componentErrors, setComponentErrors] = useState(null);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    // If User Details page is empty create result and skip page
    if (campaign && !campaign.askForSocioDemoWebSurvey) {
      if (!userDetailsCompleted) {
        setUserDetailsCompleted(true);
      }
      submitUserDetails();
    }
  }, []);

  const languageChoices = {
    English: 'EN',
    Dutch: 'NL',
    French: 'FR',
    German: 'DE'
  };

  const submitUserDetails = () => {
    document.documentElement.scrollTop = 0;
    setComponentErrors(null);

    const userDataVariables = {
      ...userDetails,
      language: languageChoices[userDetails.language]
    };

    // TODO WHY??
    delete userDataVariables.createProfile;

    const startWebSurveyVariables = {
      survey: campaign.id,
      referrer: userId,
      userData: userDataVariables,
      testing: isTesting()
    };

    if (match.params.customClientIdentifier) {
      startWebSurveyVariables.customClientIdentifier =
        match.params.customClientIdentifier;
    }
    if (match.params.customClientName) {
      startWebSurveyVariables.customClientName = match.params.customClientName;
    }
    startWebSurvey({ variables: startWebSurveyVariables });
  };

  /* eslint-disable */
  const onClickNext = () => {
    setComponentErrors(null);

    if (
      campaign.askForSocioDemoWebSurvey &&
      (!userDetails.gender ||
        !userDetails.age ||
        (!campaign.hidePostalCodeInWebSurvey && !userDetails.city))
    ) {
      setComponentErrors(translations.ALL_FIELDS_ARE_REQUIRED);
      return null;
    }

    if (!campaign.hidePostalCodeInWebSurvey && userDetails.city.length !== 4) {
      setComponentErrors(translations.PLEASE_ENTER_VALID_POSTAL_CODE);
      return null;
    }

    setUserDetailsCompleted(true);
    submitUserDetails();
  };
  /* eslint-enable */

  if (!choices || (campaign && !campaign.askForSocioDemoWebSurvey)) return null;

  return (
    <div className={styles.parentContainer}>
      <div className={styles.mainContainer}>
        <StepsProgress
          activeStep="1"
          steps={steps}
          customThemeBaseColor={customThemeBaseColor}
        />
        <div className={styles.container}>
          {!componentErrors && error && (
            <div
              className={`${
                styles.userDetailsError
              } campaign-user-detail-error`}
            >
              {error}
            </div>
          )}

          <SocioDemo
            userDetails={userDetails}
            setUserDetails={setUserDetails}
            componentErrors={componentErrors}
            translations={translations}
            hidePostalCode={campaign.hidePostalCodeInWebSurvey}
            translationInputFieldProps={translationInputFieldProps}
            onUpdateLocalCustomCopy={onUpdateLocalCustomCopy}
          />
        </div>
      </div>
      <div>
        <Footer
          onClickNext={() => onClickNext()}
          onClickBack={onClickBack}
          backLabel={translations.BACK}
          nextLabel={translations.NEXT}
          page={page}
          pages={pages}
          allowMarginTop
          hideIllustrationsInWebSurvey={
            campaign &&
            campaign.hideIllustrationsInWebSurvey &&
            campaign.customBranding
          }
          customThemeBaseColor={customThemeBaseColor}
        />
      </div>
    </div>
  );
};
